import React, { useState } from "react";
import '../../css/CssDoctorRegistration.css';
import favDocLogo from '../../assets/favdoctor logo 1.png';
import check from '../../assets/ckeck.png'
import backGround from '../../assets/favdoctor-bg.png';
import m_background from '../../assets/mbil-service.png';
import { useNavigate, Link } from "react-router-dom";
import { useStateValue } from "../../stateprovider";
import instance from '../../axios'
import Logo from '../../components/logo/Logo'
import '../land/land.css';
import LoginHeader from '../../components/Header/LoginHeader'

function Login() {
    const [{ doctor }, dispatch] = useStateValue();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState();
    const [checked, setChecked] = useState(false);
    const navigate = useNavigate();
    const [patientButton, setPatientButton] = useState(true);
    const [doctorButton, setDoctorButton] = useState(false);
    const [DocEmail, setDocEmail] = useState("");
    const [DocPassword, setDocPassword] = useState("");
    const [processing, setProcessing] = useState(false);
    const [Docprocessing, setDocProcessing] = useState(false);


    let date = new Date();
    let year = date.getFullYear();
    const handlePatientSubmit = (e) => {
        e.preventDefault();
        setProcessing(true)
        instance({
            method: 'post',
            headers: { "Content-Type": "application/json" },
            data: { email: email, password: password },
            url: '/patientLogin'
        }).then(result => {
            if (result.data.result === 0) {
                setProcessing(false);
                setMessage(result.data.googleMessage)
            } else if (result.data.result === 1) {
                setMessage(result.data.data);
                setProcessing(false);
            } else {
                // dispatch({
                //     type: "SIGN_IN_USER",
                //     s_user: result.data.user_id
                // });
                window.sessionStorage.setItem("userID", result.data.user_id)
                navigate('/');
                setProcessing(false);
            }
        })
    }
    const handleDoctorSubmit = (e) => {
        e.preventDefault();
        setDocProcessing(true)
        instance({
            method: 'post',
            headers: { "Content-Type": "application/json" },
            data: { email: DocEmail, password: DocPassword },
            url: '/doctorLogin'
        }).then(result => {
            if (result.data.result === 0) {
                setDocProcessing(false);
                setMessage(result.data.googleMessage)
            } else {
                if ((result.data.result === 1)) {
                    // dispatch({
                    //     type: "SIGN_IN_DOCTOR",
                    //     s_doctor: result.data.user_id
                    // });
                    setDocProcessing(false);
                    setMessage(result.data.data);
                } else {
                    setDocProcessing(false);
                    window.sessionStorage.setItem("userID", result.data.email);
                    navigate("/Doctor-Profile");
                }
            }
        })
        //navigate("/home")
    }
    return (
        <div className="DocRegMain">

            <div className="DocRegMain__BackgroundImage">
                <img src={backGround} alt="BackgroundImage" />
                <img src={m_background} alt="BackgroundImage"/>
            </div>
            {/* <div className="DocRegMain__Header">
                
                <article className='favdoc__land-nav' style={{ zIndex: 20 }}>
                    <Logo />
                    <div className='favdoc__land-nav_login'>
                        <Link to="/">
                            Sign Up
                        </Link>
                    </div>
                </article>
</div>*/}
            <LoginHeader />

            <div className="DocRegMain__SignUpSection">
                <div className="DocRegMain__SignUpForm Login__SignForm">
                    <p>{message}</p>
                    <p><b>Sign-In to your account</b></p>
                {/*    <div className="Login__Role">
                                    <button onClick={() => {
                                        setPatientButton(true);
                                        setDoctorButton(false);
                                    }} className={(patientButton === true) ? "disabled_button login_role_button button" : "login_role_button"} style={{ cursor: "pointer" }}><b>Patient</b></button>

                                    <button onClick={() => {
                                        setPatientButton(false);
                                        setDoctorButton(true);
                                    }} className={(doctorButton === true) ? "disabled_button login_role_button button" : "login_role_button"} style={{ cursor: "pointer" }}><b>Medical Practitioner</b></button>
                                </div>*/}
                    <div className={(patientButton === true) ? "display" : "hidden"}>
                        <form onSubmit={handlePatientSubmit}>
                            <div className={(email?.length > 3) ? "complete active input-check" : "active input-check autofill"}>
                                <input type="email" placeholder="Username or Email" value={email} onChange={(e) => setEmail(e.target.value)}
                                     name="Email" autoComplete required />
                                    <img src={check} alt="" className={(email?.length > 3) ? "display" : "check"} style={{width: "fit-content"}}/>
                            </div>
                            <div className={(password?.length > 5) ? "input-check complete active" : "active input-check autofill"}>
                                <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}  name="Password" autoComplete required />
                                    <img src={check} alt="" className={(password?.length > 5) ? "display" : "check"} style={{width: "fit-content"}}/>
                            </div>

                            <button style={{marginTop: 30 + 'px'}} className={(processing === true) ? "not-allowed disabled_button" : "disabled_button button"}>Sign In</button>

                        </form>
                        <p className="para wider" style={{ color: "#4D4D4D", paddingLeft: 30 + 'px' }}>
                            Don't have an account yet?<Link to="/user_signup_step_1" style={{ textDecoration: "none", marginLeft: 10 + "px" }}>
                                <span className="" style={{ color: "#01B6E2",  cursor: "pointer", textDecoration: "none" }}>
                                    <b>Sign Up to get Started</b></span>
                            </Link> </p>
                        <p className="para smaller" style={{ color: "#4D4D4D", }}>
                            Don't have an account yet?<Link to="/user_signup_step_1" style={{ textDecoration: "none", marginLeft: 10 + "px" }}>
                                <span className="" style={{ color: "#01B6E2",  cursor: "pointer", textDecoration: "none" }}>
                                    <b>Sign Up</b></span></Link> </p>
                        <div className="signin-check">
                            <span onClick={() => {
                                if (checked === true) {
                                    setChecked(false);
                                } else if (checked === false) {
                                    setChecked(true);
                                }
                            }} className={(checked === true) ? "geekmark" : "geekmark-checked"}></span>
                            <p style={{ paddingTop: 10 + 'px' }}>Keep me signed in</p>
                        </div>
                    </div>
                    <div className={(doctorButton === true) ? "display" : "hidden"}>
                        <form onSubmit={handleDoctorSubmit}>
                            <div className={(DocEmail.length > 3) ? "complete active input-check" : "active input-check autofill"}>
                                <input type="email" placeholder="Username or Email" value={DocEmail} onChange={(e) => setDocEmail(e.target.value)}  name="Email" autoComplete required />
                                    <img src={check} alt="" className={(DocEmail.length > 3) ? "display" : "check"} style={{width: "fit-content"}}/>
                            </div>
                            <div className={(DocPassword.length > 5) ? "input-check complete active" : "active input-check autofill"}>
                                <input type="password" placeholder="Password" value={DocPassword} onChange={(e) => setDocPassword(e.target.value)}  name="Password" autoComplete required />
                                    <img src={check} alt="" className={(DocPassword.length > 5) ? "display" : "check"} style={{width: "fit-content"}}/>
                            </div>

                            <button style={{marginTop: 30 + 'px'}} className={(Docprocessing === true) ? "not-allowed disabled_button" : "disabled_button button"}>Sign In</button>

                        </form>
                        <p className="para wider" style={{ color: "#4D4D4D", paddingLeft: 30 + 'px' }}>
                            Don't have an account yet?<Link to="/doctor_signup_step_1" style={{ textDecoration: "none", marginLeft: 10 + "px" }}>
                                <span className="" style={{ color: "#01B6E2", cursor: "pointer", textDecoration: "none" }}>
                                    <b>Sign Up to get Started</b></span>
                            </Link> </p>
                        <p className="para smaller" style={{ color: "#4D4D4D", }}>
                            Don't have an account yet?<Link to="/doctor_signup_step_1" style={{ textDecoration: "none", marginLeft: 10 + "px" }}>
                                <span className="" style={{ color: "#01B6E2", cursor: "pointer", textDecoration: "none" }}>
                                    <b>Sign Up</b></span></Link> </p>

                        <div className="signin-check">
                            <span onClick={() => {
                                if (checked === true) {
                                    setChecked(false);
                                } else if (checked === false) {
                                    setChecked(true);
                                }
                            }} className={(checked === true) ? "geekmark" : "geekmark-checked"}></span>
                            <p style={{ paddingTop: 10 + 'px' }}>Keep me signed in</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="DocRegMain__Footer">
                <div className="DocRegMain__Brand">
                    <p>&copy; {year} FavDoctor</p>
                </div>
            </div>

        </div>
    )
}

export default Login;